import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ChairmanImg from "../Assets/img/about-page/chairman-img.jpg";
import ViceChairmanImg from "../Assets/img/about-page/vice-chairman-img.jpg";
import ReadMore from "./ReadMore";

const CornerMessage = ({ index }) => {
  const [cornerMessages, setCornerMessages] = useState([]);

  useEffect(() => {
    axios.get("JSON/cornerMessagesDetail.json").then((response) => {
      setCornerMessages(
        response.data.sort((m1, m2) =>
          m1.position < m2.position
            ? -1
            : (m1, m2) => (m1.position > m2.position ? 1 : 0)
        )
      );
    });
  }, []);

  return (
    <>
      {cornerMessages?.map((cornerMessage, index) =>
        index % 2 === 0 ? (
          <div className="school-chairmen-message">
            <div className="row align-items-center">
              <div className="col-lg-6 col-12">
                <div className="s-chairmen-message-img">
                  <img src={ChairmanImg} alt="#" />
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="s-chairmen-message-content">
                  <div className="s-chairmen-message-cont-top">
                    <h4 className="s-chairmen-name">{cornerMessage?.name}</h4>
                    <span className="s-chairmen-tag">
                      {cornerMessage?.role} at e-school
                    </span>
                    <div className="s-chairmen-message-contact-info">
                      <ul className="s-chairmen-message-contact">
                        <li>
                          <Link to={`tel:${cornerMessage?.mobile_number}`}>
                            <i className="fi fi-rr-phone-call"></i>
                            {cornerMessage?.mobile_number}
                          </Link>
                        </li>
                        <li>
                          <Link to={`tel:${cornerMessage?.email}`}>
                            <i className="fi fi-rr-envelope-open"></i>
                            {cornerMessage?.email}
                          </Link>
                        </li>
                        <li>
                          <a
                            href={cornerMessage?.website}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fi fi-rr-globe"></i>
                            {cornerMessage?.website}
                          </a>
                        </li>
                      </ul>
                      <ul className="s-chairmen-message-social">
                        <li>
                          <Link to="#" target="_blank">
                            <i className="icofont-facebook"></i>
                            Facebook
                          </Link>
                        </li>
                        <li>
                          <Link to="#" target="_blank">
                            <i className="icofont-linkedin"></i>
                            Linkedin
                          </Link>
                        </li>
                        <li>
                          <Link to="#" target="_blank">
                            <i className="icofont-youtube"></i>
                            Youtube
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="s-chairmen-message-cont-bottom">
                    <h4 className="s-chairmen-message-cont-title">
                      {cornerMessage?.role} Message
                    </h4>
                    <ReadMore message_text={cornerMessage?.message_text} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="school-chairmen-message">
            <div className="row align-items-center">
              <div className="col-lg-6 col-12">
                <div className="s-chairmen-message-content">
                  <div className="s-chairmen-message-cont-top">
                    <h4 className="s-chairmen-name">{cornerMessage?.name}</h4>
                    <span className="s-chairmen-tag">
                      {cornerMessage?.role} at e-school
                    </span>
                    <div className="s-chairmen-message-contact-info">
                      <ul className="s-chairmen-message-contact">
                        <li>
                          <Link to={`tel:${cornerMessage?.mobile_number}`}>
                            <i className="fi fi-rr-phone-call"></i>
                            {cornerMessage?.mobile_number}
                          </Link>
                        </li>
                        <li>
                          <Link to={`tel:${cornerMessage?.email}`}>
                            <i className="fi fi-rr-envelope-open"></i>
                            {cornerMessage?.email}
                          </Link>
                        </li>
                        <li>
                          <a
                            href={cornerMessage?.website}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fi fi-rr-globe"></i>
                            {cornerMessage?.website}
                          </a>
                        </li>
                      </ul>
                      <ul className="s-chairmen-message-social">
                        <li>
                          <Link to="#" target="_blank">
                            <i className="icofont-facebook"></i>
                            Facebook
                          </Link>
                        </li>
                        <li>
                          <Link to="#" target="_blank">
                            <i className="icofont-linkedin"></i>
                            Linkedin
                          </Link>
                        </li>
                        <li>
                          <Link to="#" target="_blank">
                            <i className="icofont-youtube"></i>
                            Youtube
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="s-chairmen-message-cont-bottom">
                    <h4 className="s-chairmen-message-cont-title">
                      {cornerMessage?.role} Message
                    </h4>
                    <ReadMore message_text={cornerMessage?.message_text} />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="s-chairmen-message-img">
                  <img src={ViceChairmanImg} alt="#" />
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default CornerMessage;
